export default __webpack_public_path__ + "static/header-db601074a629eb0e7770225145c3cf53c72474e1dcae925c05e30b395c9b2703.png";